import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { ROUTING_SOURCE } from '../../shared/constants/routing-source';
import { CustomerAgentCreditsIcon } from '../components/CustomerAgentCreditsIcon';
import { KEEP_ASSIGNEE, ROUTING_RULE_TYPES } from './RoutingTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const getSpecificUsersAndTeamsOption = (showHelpText, routingSource) => {
  const helpText = routingSource === ROUTING_SOURCE.HELP_DESK ? I18n.text('routing-ui.routingRules.options.usersAndTeamsDescription') : I18n.text('routing-ui.routingRules.options.genericUsersAndTeamsDescription');
  return {
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: ROUTING_RULE_TYPES.USERS_AND_TEAMS,
    help: showHelpText && /*#__PURE__*/_jsx(Text, {
      as: "small",
      wordBreak: "keep-all",
      color: "text-core-subtle",
      children: helpText
    })
  };
};
const getAnyUserOption = text => ({
  text: text || I18n.text('routing-ui.routingRules.options.anyUser'),
  value: ROUTING_RULE_TYPES.INBOX_USERS
});
const getKeepAssigneeOption = (disabled = false) => ({
  text: I18n.text('routing-ui.routingRules.options.keepCurrentAssignment'),
  value: KEEP_ASSIGNEE,
  disabled
});
const getUnassignedOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.unassigned'),
  value: ROUTING_RULE_TYPES.UNASSIGNED
});
const getContactOwnerOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.contactOwner'),
  value: ROUTING_RULE_TYPES.OWNER
});
const getCustomerAgentOption = (shouldUseCustomerAgentRule, showHelpText, routingSource, isUngatedForInboundCredits) => {
  const helpText = routingSource === ROUTING_SOURCE.HELP_DESK ? I18n.text('routing-ui.routingRules.options.customerAgentDescription') : I18n.text('routing-ui.routingRules.options.genericCustomerAgentDescription');
  return {
    icon: isUngatedForInboundCredits ? CustomerAgentCreditsIcon : undefined,
    text: I18n.text('routing-ui.routingRules.options.customerAgent'),
    value: shouldUseCustomerAgentRule ? ROUTING_RULE_TYPES.CUSTOMER_AGENT : ROUTING_RULE_TYPES.AI_CHATBOT,
    help: showHelpText && /*#__PURE__*/_jsx(Text, {
      as: "small",
      wordBreak: "keep-all",
      color: "text-core-subtle",
      children: helpText
    })
  };
};
const getTeamsOnlyOption = () => ({
  text: I18n.text('routing-ui.routingRules.options.teamOnly'),
  value: ROUTING_RULE_TYPES.TEAMS_ONLY,
  help: /*#__PURE__*/_jsx(Text, {
    as: "small",
    wordBreak: "keep-all",
    color: "text-core-subtle",
    children: I18n.text('routing-ui.routingRules.options.teamOnlyDescription')
  })
});
export const getRoutingTypeOptions = config => {
  const {
    aiChatbotId,
    disableKeepAssignee = false,
    isUngatedForTeamsOnly = false,
    isUngatedForInboundCredits = false,
    shouldUseCustomerAgentRule = false,
    overrides = {},
    routingSource,
    showAnyUser = false,
    showKeepAssignee = false,
    showOwner = true,
    showTeamsOnly = false,
    showUnassigned = true
  } = config;
  const options = [];
  if (showAnyUser) {
    options.push(getAnyUserOption(overrides.anyUser));
  }
  if (showKeepAssignee) {
    options.push(getKeepAssigneeOption(disableKeepAssignee));
  }
  if (aiChatbotId) {
    options.push(getCustomerAgentOption(shouldUseCustomerAgentRule, isUngatedForTeamsOnly, routingSource, isUngatedForInboundCredits));
  }
  options.push(getSpecificUsersAndTeamsOption(isUngatedForTeamsOnly, routingSource));
  if (showTeamsOnly) {
    options.push(getTeamsOnlyOption());
  }
  if (showOwner) {
    options.push(getContactOwnerOption());
  }
  if (showUnassigned) {
    options.push(getUnassignedOption());
  }
  return options;
};
export const getFallbackRoutingTypeOptions = showTeamsOnly => {
  const fallbackOptions = [{
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: ROUTING_RULE_TYPES.USERS_AND_TEAMS,
    help: showTeamsOnly && /*#__PURE__*/_jsx(Text, {
      as: "small",
      wordBreak: "keep-all",
      color: "text-core-subtle",
      children: I18n.text('routing-ui.routingRules.options.usersAndTeamsDescription')
    })
  }];
  if (showTeamsOnly) {
    fallbackOptions.push({
      text: I18n.text('routing-ui.routingRules.options.teamOnly'),
      help: /*#__PURE__*/_jsx(Text, {
        as: "small",
        wordBreak: "keep-all",
        color: "text-core-subtle",
        children: I18n.text('routing-ui.routingRules.options.teamOnlyDescription')
      }),
      value: ROUTING_RULE_TYPES.TEAMS_ONLY
    });
  }
  fallbackOptions.push({
    text: I18n.text('routing-ui.routingRules.options.unassigned'),
    value: ROUTING_RULE_TYPES.UNASSIGNED
  });
  return fallbackOptions;
};
export const getSendFromGroupOptions = () => {
  return [{
    text: I18n.text('routing-ui.routingRules.options.usersAndTeams'),
    value: ROUTING_RULE_TYPES.USERS_AND_TEAMS
  }, {
    text: I18n.text('routing-ui.routingRules.options.contactOwner'),
    value: ROUTING_RULE_TYPES.OWNER
  }, {
    text: I18n.text('routing-ui.routingRules.options.inbox'),
    value: ROUTING_RULE_TYPES.INBOX_USERS
  }];
};